<template>
  <div class="game-chat">
    <v-alert
      :value="showAlert"
      :type="isSuccess ? 'success' : 'error'"
      transition="scale-transition"
      class="game-chat__alert"
    >
      {{ alertText }}
    </v-alert>

    <promo-code-modal
      v-show="showModal"
      :selectedItem="selectedItem"
      :modalTitle="modalTitle"
      :action="action"
      :showModal="showModal"
      @close="showModal = false"
    />

    <v-text-field
      v-model="search"
      class="game-chat__search"
      append-icon="search"
      label="Поиск"
      color="accent"
      single-line
      hide-details
    />

    <v-btn
      fab
      color="secondary"
      class="promo-codes__add"
      @click="showModal = true"
    >
      <v-icon
        small
        @click="createItem"
      >
        add
      </v-icon>
    </v-btn>

    <paginated-table
      :items="promoCodes"
      :pullFunction="getPromoCodes"
      :headers="headers"
      :pagination.sync="pagination"
      :search="search"
      :loading="loading"
    >
      <template #items="props">
        <td v-for="(header, i) in headers" :key="i">{{ props.item[header.value] }}</td>
      </template>
      <template #items="props">
        <td>{{ formDateTimeSec(props.item.created_at) }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.prize }}</td>
        <td>{{ props.item.activations_max_count }}</td>
        <td>{{ props.item.activations_count }}</td>
        <td>{{ props.item.prizes_sum }}</td>
        <td>
          <v-btn
            fab
            small
            color="secondary"
            style="display: inline"
          >
            <v-icon
              small
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
          </v-btn>
          <v-btn
            fab
            small
            color="secondary"
            style="display: inline"
          >
            <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </v-btn>
        </td>
      </template>
    </paginated-table>

    <Base--SideButtons class="game-chat__buttons" back />
  </div>
</template>

<script>
import axios from 'axios'
import { baseURL } from '../api/config'
import PromoCodeModal from '../components/modals/PromoCodeModal.vue'
import VueMixin from '../components/VueMixin'

export default {
  components: {
    PromoCodeModal
  },
  mixins: [VueMixin],
  data: () => ({
    promoCodes: [],
    search: '',
    message: '',
    loading: true,
    showModal: false,
    modalTitle: '',
    selectedItem: null,
    indexItem: 0,
    action: 'create',
    alertText: '',
    showAlert: false,
    isSuccess: true,
    blockTime: 0,
    newMessage: '',
    dialogHidden: true,
    pagination: {
      sortBy: 'created_at',
      descending: true
    },
    headers: [
      { text: 'Дата/время создания', value: 'created_at' },
      { text: 'Название', value: 'name' },
      { text: 'Промокод', value: 'code' },
      { text: 'Сумма промокода', value: 'prize' },
      { text: 'Max кол-во активаций', value: 'activations_max_count' },
      { text: 'Кол-во активаций', value: 'activations_count' },
      { text: 'Выдано средств', value: 'prizes_sum' },
      { text: 'Действия', sortable: false }]
  }),
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  mounted () {
    this.getPromoCodes(1)
    EventBus.$on('code-emit', data => {
      this.getPromoCodes(1)
      this.alertText = data.alertText
      if ('isSuccess' in data) this.isSuccess = data.isSuccess
      this.showAlert = true
      this.animateAlert()
    })
  },
  beforeDestroy () {
    EventBus.$off('code-emit')
  },
  methods: {
    close () {
      this.showModal = false
      this.selectedItem = null
    },
    createItem () {
      this.modalTitle = 'Добавление промокода'
      this.action = 'create'
      this.showModal = true
    },
    editItem (item) {
      this.modalTitle = 'Редактирование промокода'
      this.selectedItem = item
      this.action = 'edit'
      this.showModal = true
    },
    deleteItem (item) {
      this.modalTitle = 'Удаление промокода'
      this.selectedItem = item
      this.action = 'delete'
      this.showModal = true
    },
    getPromoCodes (page) {
      const offset = (page - 1) * 25
      const url = `${baseURL}/promo-codes?limit=${26}&offset=${offset}&sort=created_at:desc`
      axios
        .get(url)
        .then(({ data }) => {
          this.promoCodes = data
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss">
  .game-chat, .support-chat {
    &__alert {
      width: 30%;
      position: absolute !important;
      right: auto;
      margin: -7px 0px 0px 0px !important;
      border: unset;
    }
  }
  .promo-codes {
    &__add {
      position: absolute !important;
      top: 0px;
      right: 7px;
    }
  }
  .user_link.theme--light.v-btn {
    box-shadow: none !important;
    width: fit-content;
    background: none !important;
    line-height: 30px;
    text-transform: none;
    display: block;
    margin: 0px;
    padding: 0px;
    .v-btn__content {
      margin: 0;
    }
  }
  .v-btn--floating.v-btn--small .v-icon {
    font-size: 29px;
  }
  .v-card__text.text-block {
    position: relative;
  }
</style>
